/* ============================================================
   Funday — Reverie Collection
   Client-side sort + tag filter for the collection grid.
   Operates on the products already rendered on the page.
   For very large collections, rely on Shopify's native
   collection sort/filter URLs instead.
   ============================================================ */
(function () {
  'use strict';

  function initGrid(section) {
    var list = section.querySelector('[data-reverie-list]');
    if (!list) return;

    var cards = Array.prototype.slice.call(list.querySelectorAll('[data-reverie-card]'));
    var originalOrder = cards.slice();
    var sortEl = section.querySelector('[data-reverie-sort]');
    var filterWrap = section.querySelector('[data-reverie-filters]');
    var activeFilter = 'all';

    function applyFilter() {
      cards.forEach(function (card) {
        var tags = (card.getAttribute('data-tags') || '').split(',');
        var match = activeFilter === 'all' || tags.indexOf(activeFilter) !== -1;
        card.hidden = !match;
      });
    }

    function applySort() {
      if (!sortEl) return;
      var value = sortEl.value;
      var sorted = originalOrder.slice();

      if (value === 'price-ascending') {
        sorted.sort(function (a, b) { return num(a, 'data-price') - num(b, 'data-price'); });
      } else if (value === 'price-descending') {
        sorted.sort(function (a, b) { return num(b, 'data-price') - num(a, 'data-price'); });
      } else if (value === 'title-ascending') {
        sorted.sort(function (a, b) { return str(a).localeCompare(str(b)); });
      } else if (value === 'created-descending') {
        sorted.sort(function (a, b) { return num(b, 'data-created') - num(a, 'data-created'); });
      }
      // 'manual' falls through to original order

      sorted.forEach(function (card) { list.appendChild(card); });
    }

    function num(el, attr) { return parseInt(el.getAttribute(attr), 10) || 0; }
    function str(el) { return (el.getAttribute('data-title') || '').toLowerCase(); }

    if (sortEl) {
      sortEl.addEventListener('change', function () { applySort(); applyFilter(); });
    }

    if (filterWrap) {
      filterWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-filter]');
        if (!btn) return;
        activeFilter = btn.getAttribute('data-filter');
        filterWrap.querySelectorAll('[data-filter]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        applyFilter();
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-reverie-grid]').forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when the section is edited in the Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var grid = e.target.querySelector('[data-reverie-grid]');
    if (grid) initGrid(grid);
  });
})();
